import { Scenario } from '@scenario/models/scenario.model';
import { ScenarioEntity } from './scenario.entity';
import { PMF_BASECASE_PREFIX, PMF_MAX_YEAR, PMF_SOURCE } from '@configurations/scenario/source-year-limits.configuration';
import { Analyst } from '@scenario/models/analyst.model';

export class ScenarioMapper {
  mapToModel(scenario: ScenarioEntity): Scenario {
    return {
      source: scenario.source,
      unifiedPublicationDate: scenario.unifiedPublicationDate,
      sourcePublicationDate: scenario.sourcePublicationDate,
      type: 'price',
      subtype: scenario.subtype,
      zoneName: scenario.zoneName,
      zoneAlias: scenario.zoneAlias,
      basecase: scenario.basecase,
      weatherYear: scenario.weatherYear,
      analyst: this.mapAnalyst(scenario),
      pmoFileUrl: scenario.pmoFileUrl,
      pmoOriginalFileName: scenario.pmoOriginalFileName,
      pricePerYear: this.applyYearLimit(scenario.source, scenario.basecase, this.mapPrice(scenario.prices)),
      historicalPricePerYear: this.mapPrice(scenario.historicalPrices ?? []),
      historicalCurrency: scenario.historicalCurrency,
    };
  }

  private readonly mapPrice = (prices: { year: number; price: number | null }[]) => {
    return prices.reduce(
      (acc: Record<number, number | null>, price: { year: number; price: number | null }) => {
        acc[price.year] = price.price;
        return acc;
      },
      {} as Record<number, number | null>,
    );
  };

  private readonly applyYearLimit = (source: string, basecase: string, pricePerYear: Record<number, number | null>): Record<number, number | null> => {
    if (source === PMF_SOURCE && basecase.startsWith(PMF_BASECASE_PREFIX)) {
      return Object.fromEntries(
        Object.entries(pricePerYear).filter(([year]) => Number(year) <= PMF_MAX_YEAR)
      );
    }
    return pricePerYear;
  };

  mapAnalyst = (scenario: ScenarioEntity): Analyst | undefined => {
    if (scenario.analystFullname || scenario.analystEmail) {
      return {
        fullname: scenario.analystFullname,
        email: scenario.analystEmail,
      };
    }
    return undefined;
  };

  mapArrayToModel(scenarios: ScenarioEntity[]): Scenario[] {
    return scenarios.map(scenario => this.mapToModel(scenario));
  }
}
